export const attributes = {
  get_all: "products/attribute/",
  create: "products/attribute/",
  get_by_id: (id: number) => `products/attribute/get-by/?id=${id}`,
  delete: (id: number) => `products/attribute/?id=${id}`,
  edit: (id: number) => `products/attribute/?id=${id}`,
};
